export enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
}
